/**
 * Flag "aviso de privacidad pendiente" (T019). Lo enciende el root al recibir
 * `FERMIN_EVENTS.privacyRequired` (428 `PRIVACY_NOTICE_REQUIRED`) y lo apaga la pantalla de
 * aceptación de US2 tras `POST /privacy/accept`. Persiste en `sessionStorage` (nunca en
 * localStorage, implementation-notes 002 §4) para sobrevivir a una recarga dentro de la sesión.
 */
import { useSyncExternalStore } from 'react';

export const PRIVACY_REQUIRED_STORAGE_KEY = 'fermin:privacy-required';

const listeners = new Set<() => void>();

function readStored(): boolean {
  try {
    return globalThis.sessionStorage?.getItem(PRIVACY_REQUIRED_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function writeStored(value: boolean): void {
  try {
    if (value) {
      globalThis.sessionStorage?.setItem(PRIVACY_REQUIRED_STORAGE_KEY, '1');
    } else {
      globalThis.sessionStorage?.removeItem(PRIVACY_REQUIRED_STORAGE_KEY);
    }
  } catch {
    // Sin almacenamiento (modo privado estricto): el flag vive solo en memoria.
  }
}

let required = readStored();

export function isPrivacyRequired(): boolean {
  return required;
}

export function setPrivacyRequired(value: boolean): void {
  if (required === value) {
    return;
  }
  required = value;
  writeStored(value);
  for (const listener of listeners) {
    listener();
  }
}

export function subscribePrivacyRequired(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Hook reactivo para las pantallas (US2). */
export function usePrivacyRequired(): boolean {
  return useSyncExternalStore(subscribePrivacyRequired, isPrivacyRequired, () => false);
}
